import { NodeSelection } from "@tiptap/pm/state";
const isOnlyNodeSelected = (state, nodeId) => {
  if (state.selection instanceof NodeSelection) {
    return state.selection.node.attrs.id === nodeId;
  }
  return false;
};
export {
  isOnlyNodeSelected
};
//# sourceMappingURL=is-only-node-selected.js.map
